'use client';

import React, { useEffect, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import DepartmentEmployeeTable from './DepartmentEmployeeTable';
import InteractiveOrgChart, { orgData } from './InteractiveOrgChart';
import BackgroundPattern from '../rise-business/BackgroundPattern';
import LivingResearchBoardSection from './LivingResearchBoardSection';

/**
 * 조직도 클라이언트 컴포넌트
 * 인터랙티브 조직도와 부서 직원 테이블을 포함하는 최상위 컴포넌트입니다.
 */
const OrganizationClient: React.FC = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const queryString = searchParams.toString();
  const [selectedDepartment, setSelectedDepartment] = useState<string | null>(
    searchParams.get('department')
  );

  useEffect(() => {
    const params = new URLSearchParams(queryString);
    const department = params.get('department');
    setSelectedDepartment(department);
  }, [queryString]);

  const handleDepartmentSelect = (departmentId: string | null) => {
    const params = new URLSearchParams(searchParams.toString());
    if (departmentId) {
      params.set('department', departmentId);
    } else {
      params.delete('department');
    }
    params.delete('page');
    router.push(`?${params.toString()}`);
    setSelectedDepartment(departmentId);
  };

  return (
    <div className="mx-auto mt-8 relative overflow-hidden">
      <BackgroundPattern />
      {/* 조직도 섹션 - 항상 표시 */}
      <InteractiveOrgChart
        onDepartmentSelect={handleDepartmentSelect}
        selectedDepartment={selectedDepartment}
      />

      {/* 부서 직원 테이블 섹션 - 부서가 선택된 경우에만 표시 */}
      {selectedDepartment && (
        <DepartmentEmployeeTable
          selectedDepartment={selectedDepartment}
          orgData={orgData}
        />
      )}

      {selectedDepartment === 'living-research' && (
        <LivingResearchBoardSection />
      )}
    </div>
  );
};

export default OrganizationClient;
